import React from 'react';

import { AppOnboarding, ConfirmDialog, NoAccess } from '@vyce/core/src/components';

import { BulkClockOutDialog, TimeDialog } from './components';
import { useManualClockData } from './hooks';
import { ManualClockProvider } from './components/ManualClockProvider';
import { Props } from './types';
import { clockInText, clockOutText } from './config';

export const CoreManualClockModule = (props: Props) => {
  const {
    disableNext,
    activeStep,
    isDialogOpen,
    action,
    timestamp,
    methods,
    filteredSteps,
    childRef,
    contextOption,
    clockInTimestamp,
    isSuccessDialogOpen,
    clockedWorkerName,
    previousAction,
    missingLookupPermission,
    isBulk,
    bulkClockOut,
    setSuccessDialogClose,
    handleNext,
    setActiveStep,
    setDialogClose,
    onChangeDate,
  } = useManualClockData(props);

  // Clocking someone in is one right, finding them is another. With only the
  // first, every step of the wizard is a dead end — so say which right is
  // missing rather than hiding a tab the person was explicitly granted.
  if (missingLookupPermission) {
    return (
      <NoAccess
        title="Manual clock in/out isn’t available yet"
        subtitle="Clocking someone in or out starts by finding them, and that needs permission to look up workers. Please contact your company Admin."
      />
    );
  }

  return (
    <ManualClockProvider value={contextOption}>
      <AppOnboarding
        disableNext={disableNext}
        activeStep={activeStep}
        currentMessage=""
        setActiveStep={setActiveStep}
        methods={methods}
        handleNext={handleNext}
        steps={filteredSteps}
        loading={false}
        ref={childRef}
        lastStepButtonLabel={isBulk ? 'Review' : undefined}
      />
      <TimeDialog
        isOpen={isDialogOpen}
        action={action}
        value={timestamp === 'now' ? null : timestamp}
        onClose={setDialogClose}
        onChange={onChangeDate}
        clockInTimestamp={clockInTimestamp}
      />

      <ConfirmDialog
        handleClose={setSuccessDialogClose}
        open={isSuccessDialogOpen}
        confirmText="OK"
        title="Done!"
        showCancelText={false}
        subtitle={`${clockedWorkerName} ${previousAction === 'in' ? clockInText : clockOutText}`}
        handleConfirm={setSuccessDialogClose}
      />

      <BulkClockOutDialog
        isOpen={bulkClockOut.isOpen}
        params={bulkClockOut.params}
        workers={bulkClockOut.workers}
        selectedIds={bulkClockOut.selectedIds}
        loading={bulkClockOut.loading}
        submitting={bulkClockOut.submitting}
        result={bulkClockOut.result}
        onClose={bulkClockOut.close}
        onToggleWorker={bulkClockOut.toggleWorker}
        onToggleAll={bulkClockOut.toggleAll}
        onConfirm={bulkClockOut.confirm}
      />
    </ManualClockProvider>
  );
};
